/** Leave the current page after a session is torn down.
 *
 * Redux builds its auth state from localStorage at module load, so clearing
 * storage alone leaves the UI stale — the header keeps showing "Log Out".
 * Only a document navigation rebuilds that state. Assigning the current URL to
 * href would be a no-op reload loop risk, so reload() is used when already home.
 *
 * Callers must only invoke this when a session actually existed; an anonymous
 * 401 that reloads would reload forever.
 */
const redirectHome = () => {
  if (window.location.pathname !== "/") {
    window.location.href = "/";
  } else {
    window.location.reload();
  }
};

export default redirectHome;
